import { render, staticRenderFns } from "./pricing-compare-table.vue?vue&type=template&id=638e0a15&scoped=true&"
import script from "./pricing-compare-table.vue?vue&type=script&lang=js&"
export * from "./pricing-compare-table.vue?vue&type=script&lang=js&"
import style0 from "./pricing-compare-table.vue?vue&type=style&index=0&id=638e0a15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e0a15",
  null
  
)

export default component.exports